import React, { useState } from "react";
import { useEffect, useRef } from "react";
import FormConfig from "../../Config/FormConfig";
import APIService from "../../Service/APIService";
import { Formik } from "formik";
import useInvoiceCompletion from "./useInvoiceCompletion";
import Swal from "sweetalert2";
import * as yup from "yup";
import dayjs from "dayjs";
import CommonButton from "../../common/button/button.js";
import ModalView from "../../common/modal/index.js";
import TextInput from "../../common/text-input/index.js";
import Text from "../../common/typography/text.js";
import { message, Upload, Button } from "antd";
import DatePickerComponent from "../../common/date-picker/index.js";
import { UploadOutlined } from "@ant-design/icons";
import { useAuth } from "../AuthProvider.js";
import InvoiceProductDetailsSection from "./InvoiceProductDetailsSection.js";

const DUPLICATE_TISSUE_ID_MESSAGE = "Duplicate Tissue ID in this invoice";
const TISSUE_ID_CHECK_ERROR_MESSAGE = "Error checking Tissue ID";

const normalizeTissueId = (value) => value?.trim().toUpperCase() ?? "";
const normalizeCurrencyValue = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const normalizeDateValue = (value) => (value === null || value === undefined ? null : dayjs(value));

const InvoiceFormNew = (props) => {
  const { user } = useAuth();
  const userData = user;
  const { orderType, orderData, showInvoiceModal, onClose } = props;
  // const [showInvoiceModal, setShowInvoiceModal] = useState(false);

  const [fieldsArr, setFieldsArr] = React.useState([]);
  const [initialValues, setInitialValues] = React.useState(null);
  const [validationSchema, setValidationSchema] = React.useState(null);
  const [invoiceTotal, setInvoiceTotal] = useState(0);
  const [prevData, setPrevData] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [serializedProducts, setSerializedProducts] = useState([]);
  const [nonSerializedProducts, setNonSerializedProducts] = useState([]);

  const getInvoiceData = async () => {
    console.log("Inside Get Invoice Data");
    const apiServ = new APIService();
    const response = await apiServ.getDataFromBackend(
      `getinvoicedata?OrderID=${orderData.ID}&OrderType=${orderType}`
    );
    console.log("Invoice Data Response: ", response);
    const data = response?.data?.data;
    console.log("Invoice Data: ", data);
    // setInvoiceData(data);
    return data;
    // replace null with empty string
  };

  const getOrderProducts = async (tempInvoice) => {
    console.log("Inside Get Order Products");
    let response = null;
    const apiServ = new APIService();
    if (tempInvoice) {
      // getinvoiceproucts
      response = await apiServ.getDataFromBackend(
        `getinvoiceproucts?InvoiceID=${tempInvoice.ID}`
      );
      console.log("Order Products Response: ", response);
      // const data = response?.data?.data;
      const SerializedProducts = response?.data?.data?.SerializedProducts;
      const NonSerializedProducts = response?.data?.data?.NonSerializedProducts;
      // replace null with empty string
      let serializedData = [];
      let nonSerializedData = [];
      let j = 1;
      let totalSum = 0;

      SerializedProducts?.forEach((item) => {
        const obj = {
          ID: item["ID"],
          TissueID: item["TissueID"] ? item["TissueID"] : "",
          ProductID: item["ProductID"],
          ProductCode: item["ProductCode"],
          ProductName: item["ProductName"],
          ProductTotal: item["ProductTotal"],
          Price: item["Price"],
          OrderProductID: item["OrderProductID"],
          AccountID: orderData["AccountID"],
          AccountName: orderData["AccountName"],
          ManufacturerID: orderData["ManufacturerID"],
          ManufacturerName: orderData["ManufacturerName"],
          OrderID: orderData["OrderID"],
          OrderType: orderType,
          ExpirationDate:
            item["ExpirationDate"] === null
              ? null
              : dayjs(item["ExpirationDate"]),
          IsUsed: item["IsUsed"],
          Serialized: true,
          ShipDate: item["ShipDate"] === null ? null : dayjs(item["ShipDate"]),
          LineIndex: item["LineIndex"] ?? j - 1,
          // ShipDate: null,
          key: j++,
        };
        totalSum += Number(item["Price"]);
        serializedData.push(obj);
      });

      NonSerializedProducts?.forEach((item) => {
        const obj = {
          ID: item["ID"],
          TissueID: item["TissueID"] ? item["TissueID"] : "",
          ProductID: item["ProductID"],
          ProductCode: item["ProductCode"],
          ProductName: item["ProductName"],
          ProductTotal: item["ProductTotal"],
          Price: item["Price"],
          OrderProductID: item["OrderProductID"],
          AccountID: orderData["AccountID"],
          AccountName: orderData["AccountName"],
          ManufacturerID: orderData["ManufacturerID"],
          ManufacturerName: orderData["ManufacturerName"],
          OrderID: orderData["OrderID"],
          OrderType: orderType,
          ExpirationDate:
            item["ExpirationDate"] === null
              ? null
              : dayjs(item["ExpirationDate"]),
          IsUsed: item["IsUsed"],
          Serialized: false,
          ShipDate: item["ShipDate"] === null ? null : dayjs(item["ShipDate"]),
          LineIndex: item["LineIndex"] ?? j - 1,
          key: j++,
        };
        totalSum += Number(item["Price"]);
        nonSerializedData.push(obj);
      });

      setInvoiceTotal(totalSum);
      return { serializedData, nonSerializedData, totalSum };
    } else {
      response = await apiServ.getDataFromBackend(
        `getorderproducts?orderID=${orderData.ID}&orderType=${orderType}`
      );
      console.log("Order Products Response: ", response);
      const SerializedProducts = response?.data?.data?.SerializedProducts;
      const NonSerializedProducts = response?.data?.data?.NonSerializedProducts;
      const ProductLineDetails = response?.data?.data?.ProductLineDetails ?? [];
      const stagedLineByKey = new Map(
        ProductLineDetails.map((item) => [
          `${item.OrderProductID}:${item.LineIndex}`,
          item,
        ])
      );
      // replace null with empty string
      let serializedData = [];
      let nonSerializedData = [];
      let j = 1;
      let totalSum = 0;
      SerializedProducts?.forEach((item) => {
        const qty = Number(item["Quantity"]);
        for (let i = 0; i < qty; i++) {
          const stagedLine = stagedLineByKey.get(`${item["ID"]}:${i}`);
          const obj = {
            ID: item["ID"],
            TissueID: stagedLine?.TissueID ?? (item["TissueID"] ? item["TissueID"] : ""),
            ProductID: item["ProductID"],
            ProductCode: item["ProductCode"],
            ProductName: item["ProductName"],
            ProductTotal: item["ProductTotal"],
            Price: stagedLine?.Price ?? item["Price"],
            OrderProductID: item["ID"],
            AccountID: orderData["AccountID"],
            AccountName: orderData["AccountName"],
            ManufacturerID: orderData["ManufacturerID"],
            ManufacturerName: orderData["ManufacturerName"],
            OrderID: orderData["ID"],
            OrderType: orderType,
            ExpirationDate: normalizeDateValue(stagedLine?.ExpirationDate ?? item["ExpirationDate"]),
            IsUsed: stagedLine?.IsUsed ?? item["IsUsed"],
            Serialized: true,
            ShipDate: normalizeDateValue(stagedLine?.ShipDate ?? item["ShipDate"]),
            LineIndex: i,
            key: j++,
          };
          totalSum += Number(item["Price"]);
          serializedData.push(obj);
        }
      });

      NonSerializedProducts?.forEach((item) => {
        const qty = Number(item["Quantity"]);
        for (let i = 0; i < qty; i++) {
          const stagedLine = stagedLineByKey.get(`${item["ID"]}:${i}`);
          const obj = {
            ID: item["ID"],
            TissueID: stagedLine?.TissueID ?? (item["TissueID"] ? item["TissueID"] : ""),
            ProductID: item["ProductID"],
            ProductCode: item["ProductCode"],
            ProductName: item["ProductName"],
            ProductTotal: item["ProductTotal"],
            Price: stagedLine?.Price ?? item["Price"],
            OrderProductID: item["ID"],
            AccountID: orderData["AccountID"],
            AccountName: orderData["AccountName"],
            ManufacturerID: orderData["ManufacturerID"],
            ManufacturerName: orderData["ManufacturerName"],
            OrderID: orderData["ID"],
            OrderType: orderType,
            ExpirationDate: normalizeDateValue(stagedLine?.ExpirationDate ?? item["ExpirationDate"]),
            IsUsed: stagedLine?.IsUsed ?? item["IsUsed"],
            Serialized: false,
            ShipDate: normalizeDateValue(stagedLine?.ShipDate ?? item["ShipDate"]),
            LineIndex: i,
            key: j++,
          };
          totalSum += Number(item["Price"]);
          nonSerializedData.push(obj);
        }
      });

      setInvoiceTotal(totalSum);
      console.log("Order Products Data: ", serializedData);
      return { serializedData, nonSerializedData, totalSum };
    }
  };

  const generateInitialValues = (fieldVal, data = null) => {
    let obj = {};
    // console.log("Data: ", data);
    if (!data) {
      for (const cur of fieldVal) {
        obj[cur.backendName] = null;
      }
    } else {
      for (const cur of fieldVal) {
        obj[cur.backendName] =
          cur.backendName in data ? data[cur.backendName] : null;
      }
    }
    return obj;
  };

  const generateValidationSchema = (formFieldArr) => {
    let obj = {}; // schema object
    for (const cur of formFieldArr) {
      obj[cur.backendName] = cur.validationFunction;
    }
    return obj;
  };

  const generateFieldsArray = () => {
    const invoiceFields = FormConfig.InvoiceForm;
    console.log("invoice fields: ", invoiceFields);
    setFieldsArr(invoiceFields);
    const val = generateInitialValues(invoiceFields, orderData);
    setValidationSchema(
      yup.object().shape(generateValidationSchema(invoiceFields))
    );
    console.log("Initial Values: ", val);
    val["OrderType"] =
      val["OrderType"] === "DO" || val["OrderType"] === "Direct Order"
        ? "Direct Order"
        : val["OrderType"];
    val["InvoiceDate"] =
      val["InvoiceDate"] === null ? null : dayjs(val["InvoiceDate"]);
    val["InvoiceDueDate"] =
      val["InvoiceDueDate"] === null ? null : dayjs(val["InvoiceDueDate"]);
    if (val["ShippingCost"] === null || val["ShippingCost"] === undefined) {
      val["ShippingCost"] = 0;
    }
    setUploadInvoiceFileBlobName(val["UploadInvoiceFileBlobName"]);
    setFileName(val["UploadInvoiceFileName"]);
    if (val["UploadInvoiceFileName"]) {
      setUploadFileList([
        { name: val["UploadInvoiceFileName"], status: "done", uid: "1" },
      ]);
    }
    setInitialValues(val);
  };

  useEffect(() => {
    console.log("InvoiceForm component mounted");
    console.log("order data:", orderData);
    console.log("order type:", orderType);
    let tempInvoice = null;
    getInvoiceData()
      .then((invoice) => {
        tempInvoice = invoice;
        if (invoice) {
          console.log("Invoice Data: ", invoice);
          setInvoiceData(invoice);
          const invoiceFields = FormConfig.InvoiceForm;
          setFieldsArr(invoiceFields);
          const val = generateInitialValues(invoiceFields, invoice);
          val["OrderType"] =
            val["OrderType"] === "DO" || val["OrderType"] === "Direct Order"
              ? "Direct Order"
              : val["OrderType"];
          val["InvoiceDate"] =
            val["InvoiceDate"] === null ? null : dayjs(val["InvoiceDate"]);
          val["InvoiceDueDate"] =
            val["InvoiceDueDate"] === null
              ? null
              : dayjs(val["InvoiceDueDate"]);
          setUploadInvoiceFileBlobName(val["UploadInvoiceFileBlobName"]);
          setFileName(val["UploadInvoiceFileName"]);
          if (val["UploadInvoiceFileName"]) {
            setUploadFileList([
              { name: val["UploadInvoiceFileName"], status: "done", uid: "1" },
            ]);
          }
          setInitialValues(val);
        } else {
          generateFieldsArray();
        }
      })
      .then(() => {
        getOrderProducts(tempInvoice)
          .then(({ serializedData, nonSerializedData, totalSum }) => {
            console.log("Get Order Products called");
            setSerializedProducts(serializedData);
            setNonSerializedProducts(nonSerializedData);
            // setOrderProducts(newData);
            // setSelectedData(newData);
          })
          .catch((error) => {
            console.log("Error in getting order products: ", error);
          });
      });

    // setOrderProductsColumns(generateSchema());
  }, []);

  const calculateInvoiceTotal = (serializedData, nonSerializedData) => {
    const data = [...serializedData, ...nonSerializedData];
    let total = 0;
    data.map((ele) => {
      total += Number(ele.Price);
    });
    setInvoiceTotal(total);
  };

  const [showLoader, setShowLoader] = useState(false);

  const { runCompletion, confirmCompletion, isCompleting } = useInvoiceCompletion();

  const [uploadInvoice, setUploadInvoice] = React.useState(null);
  const [uploadFileList, setUploadFileList] = React.useState([]);
  const [isFileUpdated, setIsFileUpdated] = React.useState(false);
  const [fileName, setFileName] = React.useState(null);
  const [uploadInvoiceFileBlobName, setUploadInvoiceFileBlobName] =
    React.useState(null);

  const handleFile = async ({ file, onSuccess }) => {
    if (file.size > 4194304) {
      message.error("File size should be less than 4MB");
      setFileName(null);
      setUploadInvoiceFileBlobName(null);
      setUploadInvoice(null);
      setUploadFileList([]);
      return;
    }
    setIsFileUpdated(true);
    setUploadFileList([{ name: file.name, status: "done", uid: "1" }]);
    setUploadInvoice(file);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const downloadFile = async () => {
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(uploadInvoiceFileBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }
    // download the file from Azure Blob Storage
    const link = document.createElement("a");
    link.href = sasUrl;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // console.log("Download File: ", tissueTracking);
    // const url = window.URL.createObjectURL(tissueTracking);

    // // Create a link element and trigger the download
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", fileName); // Set the file name
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    // action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    accept: [".pdf"],
    // disabled: !isEditable,
    fileList: uploadFileList,
    customRequest: handleFile,
    onPreview: downloadFile,
    onRemove: (file) => {
      setUploadInvoice(null);
      setUploadFileList([]);
      setFileName(null);
      setUploadInvoiceFileBlobName(null);
    },
    onChange(info) {
      console.log("File Info: ", info);
      const { status } = info.file;
      // console.log("Status: ", status);
      if (status !== "uploading") {
        // console.log(info.file, info.fileList);
      }
      if (status === "done") {
        // setIvrReport(info.file.originFileObj);
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const buildInvoiceDuplicateMessage = (invoice) => (
    <>
      Duplicate Tissue ID found in Invoice Number{" "}
      <a
        href={`/InvoiceHome/${invoice?.ID}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {invoice?.InvoiceNumber}
      </a>
    </>
  );

  const removeRowError = (errors, rowKey) => {
    if (!(rowKey in errors)) {
      return errors;
    }
    const nextErrors = { ...errors };
    delete nextErrors[rowKey];
    return nextErrors;
  };

  const checkLocalDuplicates = (data) => {
    const rowKeysByTissueId = {};
    const errors = {};
    data.forEach((row) => {
      const normalizedTissueId = normalizeTissueId(row.TissueID);
      if (!normalizedTissueId) {
        return;
      }
      if (!rowKeysByTissueId[normalizedTissueId]) {
        rowKeysByTissueId[normalizedTissueId] = [];
      }
      rowKeysByTissueId[normalizedTissueId].push(row.key);
    });

    Object.values(rowKeysByTissueId).forEach((rowKeys) => {
      if (rowKeys.length < 2) {
        return;
      }
      rowKeys.forEach((rowKey) => {
        errors[rowKey] = DUPLICATE_TISSUE_ID_MESSAGE;
      });
    });

    return errors;
  };

  const [serverTissueErrors, setServerTissueErrors] = useState({});
  const [localDuplicateErrors, setLocalDuplicateErrors] = useState({});
  const [hasPendingTissueChecks, setHasPendingTissueChecks] = useState(false);
  const combinedTissueErrors = React.useMemo(
    () => {
      const rowKeys = new Set([
        ...Object.keys(localDuplicateErrors),
        ...Object.keys(serverTissueErrors),
      ]);
      const combinedErrors = {};

      rowKeys.forEach((rowKey) => {
        if (serverTissueErrors[rowKey]) {
          combinedErrors[rowKey] = serverTissueErrors[rowKey];
          return;
        }
        if (localDuplicateErrors[rowKey]) {
          combinedErrors[rowKey] = localDuplicateErrors[rowKey];
        }
      });

      return combinedErrors;
    },
    [serverTissueErrors, localDuplicateErrors]
  );
  const pendingChecksRef = useRef(new Set());
  const scheduledChecksRef = useRef({});
  const latestNormalizedTissueIdsRef = useRef({});
  const tissueDuplicateCheckCacheRef = useRef(new Map());

  const apiServ = new APIService();

  const syncPendingTissueChecks = () => {
    setHasPendingTissueChecks(pendingChecksRef.current.size > 0);
  };

  const clearScheduledTissueCheck = (rowKey) => {
    const scheduledCheck = scheduledChecksRef.current[rowKey];
    if (!scheduledCheck) {
      return;
    }
    clearTimeout(scheduledCheck.timeoutId);
    scheduledCheck.resolve();
    pendingChecksRef.current.delete(scheduledCheck.pendingPromise);
    delete scheduledChecksRef.current[rowKey];
    syncPendingTissueChecks();
  };

  const fetchTissueDuplicateInfo = async (value) => {
    const trimmedValue = value?.trim();
    const normalizedValue = normalizeTissueId(trimmedValue);

    if (!normalizedValue) {
      return null;
    }

    if (!tissueDuplicateCheckCacheRef.current.has(normalizedValue)) {
      const requestPromise = apiServ
        .getDataFromBackend(
          `CheckForDuplicateTissueID?TissueID=${encodeURIComponent(
            trimmedValue
          )}`
        )
        .then((res) => {
          if (
            res?.data?.exists &&
            res?.data?.invoice?.ID &&
            String(res.data.invoice.ID) !== String(invoiceData?.ID)
          ) {
            return {
              type: "invoice-duplicate",
              invoice: res.data.invoice,
            };
          }
          return null;
        })
        .catch(() => {
          tissueDuplicateCheckCacheRef.current.delete(normalizedValue);
          return {
            type: "request-error",
          };
        });

      tissueDuplicateCheckCacheRef.current.set(normalizedValue, requestPromise);
    }

    return tissueDuplicateCheckCacheRef.current.get(normalizedValue);
  };

  const applyServerTissueError = (rowKey, result) => {
    setServerTissueErrors((prev) => {
      if (result?.type === "invoice-duplicate") {
        return {
          ...prev,
          [rowKey]: buildInvoiceDuplicateMessage(result.invoice),
        };
      }
      if (result?.type === "request-error") {
        return {
          ...prev,
          [rowKey]: TISSUE_ID_CHECK_ERROR_MESSAGE,
        };
      }
      return removeRowError(prev, rowKey);
    });
  };

  const scheduleTissueIdCheck = (value, rowKey) => {
    const normalizedValue = normalizeTissueId(value);

    latestNormalizedTissueIdsRef.current[rowKey] = normalizedValue;
    clearScheduledTissueCheck(rowKey);

    if (!normalizedValue) {
      setServerTissueErrors((prev) => removeRowError(prev, rowKey));
      return;
    }

    let resolvePendingCheck;
    const pendingPromise = new Promise((resolve) => {
      resolvePendingCheck = resolve;
    });

    pendingChecksRef.current.add(pendingPromise);
    syncPendingTissueChecks();

    const timeoutId = setTimeout(async () => {
      try {
        const result = await fetchTissueDuplicateInfo(value);
        if (latestNormalizedTissueIdsRef.current[rowKey] === normalizedValue) {
          applyServerTissueError(rowKey, result);
        }
      } finally {
        pendingChecksRef.current.delete(pendingPromise);
        delete scheduledChecksRef.current[rowKey];
        resolvePendingCheck();
        syncPendingTissueChecks();
      }
    }, 350);

    scheduledChecksRef.current[rowKey] = {
      pendingPromise,
      resolve: resolvePendingCheck,
      timeoutId,
    };
  };

  const waitForAllChecks = async () => {
    await Promise.all([...pendingChecksRef.current]);
  };

  const validateBeforeAction = async () => {
    await waitForAllChecks();

    const localErrors = checkLocalDuplicates(serializedProducts);
    setLocalDuplicateErrors(localErrors);

    const serverValidationResults = await Promise.all(
      serializedProducts.map(async (row) => ({
        rowKey: row.key,
        result: await fetchTissueDuplicateInfo(row.TissueID),
      }))
    );

    const nextServerErrors = {};
    serverValidationResults.forEach(({ rowKey, result }) => {
      if (result?.type === "invoice-duplicate") {
        nextServerErrors[rowKey] = buildInvoiceDuplicateMessage(result.invoice);
        return;
      }
      if (result?.type === "request-error") {
        nextServerErrors[rowKey] = TISSUE_ID_CHECK_ERROR_MESSAGE;
      }
    });

    setServerTissueErrors(nextServerErrors);

    const combinedErrors = {
      ...localErrors,
      ...nextServerErrors,
    };

    return Object.keys(combinedErrors).length === 0;
  };

  useEffect(() => {
    setLocalDuplicateErrors(checkLocalDuplicates(serializedProducts));
  }, [serializedProducts]);

  useEffect(() => {
    tissueDuplicateCheckCacheRef.current.clear();
  }, [invoiceData?.ID]);

  useEffect(() => {
    return () => {
      Object.values(scheduledChecksRef.current).forEach((scheduledCheck) => {
        clearTimeout(scheduledCheck.timeoutId);
        scheduledCheck.resolve();
      });
      pendingChecksRef.current.clear();
      scheduledChecksRef.current = {};
    };
  }, []);

  const handleInputChange = (e, rowKey, column) => {
    const value = e.target.value;
    setSerializedProducts((prev) =>
      prev.map((row) =>
        row.key === rowKey ? { ...row, [column]: value } : row
      )
    );

    if (column === "TissueID") {
      scheduleTissueIdCheck(value, rowKey);
    }
  };

  const saveHandler = async (values) => {
    setShowLoader(true);
    const valid = await validateBeforeAction();
    if (!valid) {
      Swal.fire({
        icon: "error",
        title: "Invalid Tissue IDs",
        text: "Please fix duplicate Tissue IDs before submitting.",
      });
      setShowLoader(false);
      return;
    }
    console.log("Save Invoice");
    // Swal.fire({
    //   title: 'Are you sure?',
    //   text: "Do you want to save?",
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Yes',
    // }).then(async (result) => {
    //   if (result.isConfirmed) {
    // return;
    const apiServe = new APIService();
    // add new invoice
    const invoicePostObj = {
      OrderID: orderData.ID,
      OrderType: orderType,
      InvoiceDate: values.InvoiceDate,
      InvoiceDueDate: values.InvoiceDueDate,
      InvoiceNumber: values.InvoiceNumber,
      TrackingNumber:
        invoiceData?.TrackingNumber ?? orderData?.TrackingNumber ?? null,
      InvoiceTotal: invoiceTotal,
      PONumber: orderData.PONumber,
      InvoiceInAppeal: values.InvoiceInAppeal,
      ShippingCost: values.ShippingCost,
      AccountID: orderData.AccountID,
      AccountName: orderData.AccountName,
      ShipToAccountID: orderData.ShipToAccountID,
      ShipToAccountName: orderData.ShipToAccountName,
      ManufacturerID: orderData.ManufacturerID,
      ManufacturerName: orderData.ManufacturerName,
      AccountState: orderData.ShipState,
      // ShipDate: orderData.ShipDate,
      // ExpirationDate: orderData.ExpirationDate,
    };
    let invoiceProducts = [];
    serializedProducts.map((ele) => {
      if (orderType === "Direct Order" || orderType === "DO") {
        ele["IsUsed"] = true;
      }
      invoiceProducts.push(ele);
    });
    nonSerializedProducts.map((ele) => {
      if (orderType === "Direct Order" || orderType === "DO") {
        ele["IsUsed"] = true;
      }
      invoiceProducts.push(ele);
    });
    const postObj = {
      invoice: invoicePostObj,
      invoiceProducts: invoiceProducts,
      type: "Save",
      isFileUpdated: isFileUpdated,
    };
    let formData = new FormData();
    formData.append("data", JSON.stringify(postObj));
    formData.append("file", uploadInvoice);
    const invoiceResponse = await apiServe.addFileDataToBackend(
      formData,
      `addinvoice`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log("Invoice Post Obj: ", invoicePostObj);
    // const invoiceResponse = await apiServe.addDataToBackend(postObj, `addinvoice?type=Save`);
    console.log("Invoice Response: ", invoiceResponse);
    if (invoiceResponse && invoiceResponse?.data) {
      Swal.fire({
        icon: "success",
        text: "Invoice Added Successfully",
        timer: 1500,
      });
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      Swal.fire({
        icon: "error",
        text: "Add Invoice Failed",
        timer: 1500,
      });
    }
    // }
    //   else {
    //     setShowLoader(false);
    //   }
    // });
  };

  const performComplete = async (values, type) => {
    const isValidForm = checkFormValidity();
    if (isValidForm === false) {
      return;
    }
    setShowLoader(true);
    const valid = await validateBeforeAction();
    if (!valid) {
      Swal.fire({
        icon: "error",
        title: "Invalid Tissue IDs",
        text: "Please fix duplicate Tissue IDs before submitting.",
      });
      setShowLoader(false);
      return;
    }
    console.log("Submit Invoice");

    // check if tissue ID Added
    // if (type === "Complete") {
    //   let isValid = true;
    //   serializedProducts.map((ele) => {
    //     if (
    //       ele?.TissueID === null ||
    //       ele?.TissueID === undefined ||
    //       ele?.TissueID === ""
    //     ) {
    //       isValid = false;
    //     }
    //   });
    //   if (!isValid) {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Tissue ID missing",
    //       text: "Please add all the Tissue IDs",
    //     });
    //     setShowLoader(false);
    //     return;
    //   }
    // }

    const confirmed = await confirmCompletion({
      uploadInvoice,
      fileName,
      uploadInvoiceFileBlobName,
    });
    if (!confirmed) return;

    const apiServe = new APIService();
    // add new invoice
    const invoicePostObj = {
      OrderID: orderData.ID,
      OrderType: orderType,
      InvoiceDate: values.InvoiceDate,
      InvoiceDueDate: values.InvoiceDueDate,
      InvoiceNumber: values.InvoiceNumber,
      TrackingNumber:
        invoiceData?.TrackingNumber ?? orderData?.TrackingNumber ?? null,
      InvoiceTotal: invoiceTotal,
      PONumber: orderData.PONumber,
      InvoiceInAppeal: values.InvoiceInAppeal,
      ShippingCost: values.ShippingCost,
      AccountID: orderData.AccountID,
      AccountName: orderData.AccountName,
      ShipToAccountID: orderData.ShipToAccountID,
      ShipToAccountName: orderData.ShipToAccountName,
      ManufacturerID: orderData.ManufacturerID,
      ManufacturerName: orderData.ManufacturerName,
      AccountState: orderData.ShipState,
      // ShipDate: orderData.ShipDate,
      // ExpirationDate: orderData.ExpirationDate,
    };
    let invoiceProducts = [];
    serializedProducts.map((ele) => {
      if (orderType === "Direct Order" || orderType === "DO") {
        ele["IsUsed"] = true;
      }
      invoiceProducts.push(ele);
    });

    nonSerializedProducts.map((ele) => {
      if (orderType === "Direct Order" || orderType === "DO") {
        ele["IsUsed"] = true;
      }
      invoiceProducts.push(ele);
    });

    const postObj = {
      invoice: invoicePostObj,
      invoiceProducts: invoiceProducts,
      type: type,
      isFileUpdated: isFileUpdated,
    };
    let formData = new FormData();
    formData.append("data", JSON.stringify(postObj));
    formData.append("file", uploadInvoice);
    const invoiceResponse = await apiServe.addFileDataToBackend(
      formData,
      `addinvoice`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log("Invoice Response: ", invoiceResponse);
    if (invoiceResponse && invoiceResponse?.data) {
      Swal.fire({
        icon: "success",
        text: "Invoice Added Successfully",
        timer: 1500,
      });
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      Swal.fire({
        icon: "error",
        text: "Add Invoice Failed",
        timer: 1500,
      });
    }
  };

  const submitHandler = (values) => runCompletion(async () => {
    try {
      await performComplete(values, "Complete");
    } catch (error) {
      Swal.fire({ icon: "error", text: "Add Invoice Failed" });
    } finally {
      setShowLoader(false);
    }
  });

  const checkFormValidity = () => {
    let isValid = true;
    console.log(
      { serializedProducts },
      { nonSerializedProducts },
      "products orde >>>> 1"
    );
    serializedProducts.forEach((item) => {
      if (
        item.TissueID === null ||
        item.TissueID === "" ||
        item.TissueID === undefined
      ) {
        isValid = false;
      }
      if (
        item.Price === null ||
        item.Price === "" ||
        item.Price === undefined
      ) {
        isValid = false;
      }
    });

    nonSerializedProducts.forEach((item) => {
      if (
        item.Price === null ||
        item.Price === "" ||
        item.Price === undefined
      ) {
        isValid = false;
      }
    });

    return isValid;
  };

  return (
    <div>
      <ModalView
        isOpen={showInvoiceModal}
        onClose={() => onClose(false)}
        modalTitle={`Add Details to ${orderData?.PONumber} - ${orderData?.OrderType}`}
        textInputComponent={
          <>
            {initialValues && (
              <Formik
                onSubmit={submitHandler}
                initialValues={initialValues}
                validationSchema={validationSchema}
                validateOnMount
              >
                {(formik) => {
                  const summaryShippingCost = normalizeCurrencyValue(
                    formik.values.ShippingCost
                  );
                  const invoiceGrandTotal =
                    Number(invoiceTotal) + summaryShippingCost;

                  return (
                    <form onSubmit={formik.handleSubmit}>
                      <div className="field-group-wrapper">
                      <div className="field-group">
                        <TextInput
                          titleText="Invoice Number"
                          placeholder="Invoice Number"
                          isRequired
                          value={formik.values.InvoiceNumber}
                          // setValue={formik.handleChange}
                          setValue={(val) =>
                            formik.setFieldValue("InvoiceNumber", val)
                          }
                        />
                        <TextInput
                          titleText="Shipping Cost"
                          placeholder="Shipping Cost"
                          isRequired
                          value={formik.values.ShippingCost}
                          // setValue={formik.handleChange}
                          // setValue={(val) => formik.setFieldValue("ShippingCost", val)}
                          onChange={(e) => {
                            const val = e.target.value;
                            formik.setFieldValue("ShippingCost", val);
                          }}
                        />
                      </div>
                      <div className="field-group">
                        <DatePickerComponent
                          format="MM-DD-YYYY"
                          titleText="Invoice Date"
                          isRequired
                          value={formik.values.InvoiceDate}
                          onChange={(date) =>
                            formik.setFieldValue("InvoiceDate", date)
                          }
                        />
                        <DatePickerComponent
                          format="MM-DD-YYYY"
                          titleText="Invoice Due Date"
                          isRequired
                          value={formik.values.InvoiceDueDate}
                          onChange={(date) =>
                            formik.setFieldValue("InvoiceDueDate", date)
                          }
                        />
                        <div className="text-input-container">
                          <Text variant="tinyText">Upload Invoice</Text>
                          <Upload {...uploadProps}>
                            <Button
                              icon={<UploadOutlined />}
                              rootClassName="upload-button-container"
                            >
                              Upload
                            </Button>
                          </Upload>
                        </div>
                      </div>
                      <InvoiceProductDetailsSection
                        orderType={orderType}
                        serializedProducts={serializedProducts}
                        nonSerializedProducts={nonSerializedProducts}
                        setSerializedProducts={setSerializedProducts}
                        setNonSerializedProducts={setNonSerializedProducts}
                        calculateInvoiceTotal={calculateInvoiceTotal}
                        combinedTissueErrors={combinedTissueErrors}
                        handleInputChange={handleInputChange}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          alignSelf: "stretch",
                          gap: "16px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-end",
                            gap: "8px",
                            alignSelf: "stretch",
                          }}
                        >
                          <Text
                            variant="bodyText"
                            className="no-wrap-text-container"
                          >
                            All Products
                          </Text>

                          <hr className="divider dotted full-width" />
                          <Text variant="bold">
                            $
                            {parseFloat(invoiceTotal).toLocaleString("en-US", {
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-end",
                            gap: "8px",
                            alignSelf: "stretch",
                          }}
                        >
                          <Text
                            variant="bodyText"
                            className="no-wrap-text-container"
                          >
                            Shipping Cost
                          </Text>
                          <hr className="divider dotted full-width" />
                          <Text variant="bold">
                            $
                            {summaryShippingCost > 0
                              ? summaryShippingCost.toLocaleString(
                                  "en-US",
                                  {
                                    maximumFractionDigits: 2,
                                  }
                                )
                              : 0}
                          </Text>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-end",
                            gap: "8px",
                            alignSelf: "stretch",
                          }}
                        >
                          <Text
                            variant="bold"
                            className="no-wrap-text-container"
                          >
                            Invoice Total
                          </Text>
                          <hr className="divider dotted full-width" />
                          <Text variant="bold">
                            $
                            {invoiceGrandTotal.toLocaleString("en-US", {
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        </div>
                      </div>
                      </div>

                      <div className="footer-button-wrapper-with-margin-top">
                        {userData?.Type === "Admin" && (
                          <CommonButton
                            type="button"
                            variant="table"
                            subVariant="success"
                            onClick={(values) => {
                              console.log("values: ", formik.values);
                              saveHandler(formik.values);
                            }}
                            disabled={
                              isCompleting || formik.isSubmitting || hasPendingTissueChecks ||
                              Object.keys(combinedTissueErrors).length > 0
                            }
                          >
                            Save
                          </CommonButton>
                        )}
                        <CommonButton
                          type="button"
                          variant="table"
                          subVariant={"success"}
                          onClick={(values) => {
                            const isValidForm = checkFormValidity();
                            const submitHandlerValidity =
                              isValidForm && formik.isValid;
                            if (
                              formik.isValid === false ||
                              isValidForm === false
                            ) {
                              message.error("Please fill all the fields");
                              return;
                            } else {
                              formik.submitForm();
                            }
                          }}
                          disabled={
                            isCompleting || formik.isSubmitting || hasPendingTissueChecks ||
                            Object.keys(combinedTissueErrors).length > 0
                          }
                          // disabled={
                          //   !formik.isValid ||
                          //   (tissueErrors &&
                          //     Object.values(tissueErrors).some(
                          //       (err) => err !== null
                          //     ))
                          // }
                          // disabled={!formik.isValid && checkFormValidity()}
                        >
                          Save & Mark as Complete
                        </CommonButton>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            )}
          </>
        }
        footerButtonWrapper={<></>}
      />
    </div>
  );
};

export default InvoiceFormNew;
